import type { FC, PropsWithChildren } from 'react'

import type { RundownPermission } from '~shared/rundown/permission'

import { useRundownPermission } from '../lib/use-rundown-permission'

type PermissionsGuardProps = {
  permission: RundownPermission
}

export const RundownPermissionGuard: FC<
  PropsWithChildren<PermissionsGuardProps>
> = ({ permission, children }) => {
  const hasPermission = useRundownPermission({ permission })

  if (hasPermission) return children

  return null
}
